<template lang="pug">
  .power-profile-status
    .pps-header
      span {{ 'Device received last profile change? ' }}
      el-tag.pps-sync-tag(
        :type="transmitter.power_profile_synced ? 'success' : 'warning'"
        effect="dark"
        size="small"
      )
        i.el-icon-circle-check.mr-1(v-if="transmitter.power_profile_synced")
        i.el-icon-loading.mr-1(v-else)
        span {{ transmitter.power_profile_synced ? $t('transmitters.status.confirmed') : $t('transmitters.status.pending') }}
      el-button.el-icon-refresh-left.pps-refresh-btn(
        circle
        size="mini"
        :loading="refreshing"
        :title="$t('common.refresh')"
        @click="$emit('refresh')"
      )
    .pps-body
      .pps-block.pps-configured
        .pps-block-label
          i.el-icon-setting
          span {{ $t('transmitters.status.configured') }}
        template(v-if="transmitter.power_profile_number")
          .pps-profile-number Profile {{ transmitter.power_profile_number }}
          .pps-profile-time {{ transmitter.power_profile_human_readable }}
          .pps-profile-count
            i.el-icon-refresh
            span {{ executionCountLabel(transmitter.power_profile_execution_count) }}
        template(v-else)
          .pps-empty {{ $t('transmitters.status.no_profile_set') }}

      .pps-arrow
        i.el-icon-right(v-if="!isMobile")
        i.el-icon-bottom(v-else)

      .pps-block.pps-reported
        .pps-block-label
          i.el-icon-connection
          span {{ $t('transmitters.status.device_reported') }}
        template
          .pps-profile-number Profile {{ transmitter.reported_power_profile_number ?? 0 }}
          .pps-profile-time {{ transmitter.reported_power_profile_human_readable ?? "1 hour" }}
          .pps-profile-count
            i.el-icon-refresh
            span {{ executionCountLabel(transmitter.reported_power_profile_execution_count) }}
        //- template(v-else)
        //-   .pps-empty {{ $t('transmitters.status.no_report_yet') }}
    .pps-hint(v-if="!transmitter.power_profile_synced")
      i.el-icon-warning-outline
      span {{ $t('powerProfiles.actions.count_only_change_warning') }}
</template>

<script>
export default {
  name: "PowerProfileStatus",

  props: {
    transmitter: {
      type: Object,
      required: true,
    },
    refreshing: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isMobile: false,
    };
  },

  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },

  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },

    executionCountLabel(count) {
      console.log(count);
      if (count === 0 || count === null || count === undefined) {
        return this.$t('powerProfiles.actions.permanent');
      }
      return this.$t('transmitters.status.times_remaining', { count });
    },
  },
};
</script>

<style lang="scss" scoped>
.power-profile-status {
  background: #f7f9fa;
  border-radius: 10px;
  border: 1px solid #e4e7ec;
  padding: 16px 18px;
  margin-bottom: 16px;
}

.pps-header {
  display: flex;
  align-items: center;
  margin-bottom: 14px;

  &-icon {
    font-size: 18px;
    color: #6aa84f;
    margin-right: 8px;
  }

  &-title {
    font-weight: 600;
    color: #2d3a4a;
    flex: 1;
  }
}

.pps-refresh-btn {
  margin-left: auto;
  margin-right: 8px;
}

.pps-body {
  display: flex;
  align-items: stretch;
  gap: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
}

.pps-block {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e4e7ec;
  padding: 12px 14px;

  &.pps-reported {
    border-color: #d3e8c7;
  }
}

.pps-block-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #909399;
  margin-bottom: 8px;
}

.pps-profile-number {
  font-size: 16px;
  font-weight: 600;
  color: #2d3a4a;
}

.pps-profile-time {
  font-size: 13px;
  color: #606266;
  margin-top: 2px;
}

.pps-profile-count {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #909399;
  margin-top: 6px;

  i {
    font-size: 12px;
  }
}

.pps-empty {
  font-size: 13px;
  color: #c0c4cc;
  font-style: italic;
}

.pps-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  font-size: 18px;

  @media (max-width: 768px) {
    padding: 2px 0;
  }
}

.pps-hint {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #909399;
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px dashed #e4e7ec;

  i {
    color: #e6a23c;
  }
}

.pps-sync-tag {
  margin: 5px;
}
</style>
